import { PhotoCamera } from '@mui/icons-material';
import {
	IconButton,
	InputAdornment,
} from '@mui/material';
import React, { ChangeEvent, useRef } from 'react';
import { TextField } from '@Atoms';
import { useTranslation } from 'react-i18next';

interface FileInputProps {
	label: string;
	placeholder?: string;
	onChange: (event: ChangeEvent<HTMLInputElement>) => void;
	disabled?: boolean;
	helperText?: string | File;
	error?: boolean;
	name?: string;
	accept?: string
}
const FileInput:React.FC<FileInputProps> = (props) => {
	const { t } = useTranslation('translations');
	const {
		label,
		placeholder = t('noFileChoosen'),
		onChange,
		disabled,
		helperText,
		error,
		name,
		accept,
	} = props;
	const fileRef = useRef<HTMLInputElement | null>(null);
	const onFocus = () => {
		if (!disabled) {
			fileRef.current?.click();
		}
	};

	return (
		<>
			<input ref={fileRef} name={name} type="file" accept={accept} hidden onChange={onChange} />
			<TextField
				variant="outlined"
				placeholder={placeholder}
				fullWidth
				onClick={onFocus}
				label={label}
				disabled={disabled}
				helperText={helperText}
				error={error}
				size="small"
				InputLabelProps={{ shrink: true }}
				value={placeholder}
				InputProps={{
					readOnly: true,
					endAdornment: (
						<InputAdornment position="end">
							<IconButton disabled={disabled}>
								<PhotoCamera color="primary" />
							</IconButton>
						</InputAdornment>),
				}}
			/>
		</>

	);
};

export default FileInput;
